import {CardMarkupViewerState} from "../markup/cardMarkupViewer/cardMarkupViewer.interface";
import { ISubcard } from "../cards/multicards.interface";

export interface ReviewStateProps {
    markup: string | undefined;
    reviewState: ReviewState;
    markupState: CardMarkupViewerState | undefined;
    cardId: string | undefined;
    // MultiCard support
    isMultiCard?: boolean;
    currentSubcard?: ISubcard;
    subcardProgress?: {
        current: number;
        total: number;
    };
    hasMoreSubcards?: boolean;
    currentSubcardIndex?: number;
    // Card progress
    current?: number;
    total?: number;
}

export enum ReviewState {
    Loading = "Loading",
    OnlyQuestion = "OnlyQuestion",
    QuestionAndHint = "QuestionAndHint",
    Answer = "Answer",
    Completed = "Completed", // New state for when all cards are reviewed
    // MultiCard states
    SubcardQuestion = "SubcardQuestion",
    SubcardAnswer = "SubcardAnswer",
    SubcardTransition = "SubcardTransition",
}

export interface ReviewStore {
    cardId: string | undefined;
    state: ReviewState;
    markupState: CardMarkupViewerState | undefined;
    isExtraActionsMenuOpen: boolean;
    cardNumberInReview: number;
    totalCardsForReview: number;
    // MultiCard support
    isMultiCard: boolean;
    selectedSubcards: ISubcard[];
    currentSubcardIndex: number;
    isLastSubcard: boolean;
    showSubcardButtons: boolean;
    subcardReviewStartTime?: number;
    subcardTimings: number[];
    // Per-subcard correctness, aligned with selectedSubcards (for the heatmap)
    subcardCorrectness: boolean[];
    // Random subcards tracking
    viewedSubcardIndices: number[];
    allSubcards: ISubcard[];
}

/**
 * Extended interface for MultiCard review state
 */
export interface MultiCardReviewStore extends ReviewStore {
    isMultiCard: true;
    selectedSubcards: ISubcard[];
    currentSubcardIndex: number;
    isLastSubcard: boolean;
    showSubcardButtons: boolean;
    subcardReviewStartTime: number;
    subcardTimings: number[];
    viewedSubcardIndices: number[];
    allSubcards: ISubcard[];
}

/**
 * Type guard to check if review store is for MultiCard
 */
export function isMultiCardReviewStore(store: ReviewStore): store is MultiCardReviewStore {
    return store.isMultiCard && store.selectedSubcards.length > 0;
}



